import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { FaTimes } from "react-icons/fa";
import InvoicePreviewFrame from "./InvoicePreviewFrame";

/** Xem PDF toàn màn hình (dùng cho mobile, khi pane preview bị ẩn). */
const PdfOverlay = ({ show, url, loading, onClose }) => {
  useEffect(() => {
    if (show) document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [show]);

  if (!show) return null;
  return createPortal(
    <div className="geist-scope tw-fixed tw-inset-0 tw-z-[100060] tw-bg-geist-bg tw-flex tw-flex-col">
      <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-border-b tw-border-solid tw-border-geist-border tw-bg-geist-bg-2 tw-flex-shrink-0">
        <span className="tw-text-sm tw-font-semibold tw-text-geist-fg">Invoice preview</span>
        <div role="button" tabIndex={0} onClick={onClose}
          className="tw-p-1.5 tw-rounded-geist-sm tw-text-geist-fg-2 hover:tw-bg-geist-100 tw-cursor-pointer"><FaTimes size={18} /></div>
      </div>
      <div className="tw-flex-1 tw-min-h-0 tw-bg-geist-bg-2">
        <InvoicePreviewFrame url={url} loading={loading} />
      </div>
    </div>,
    document.body
  );
};

PdfOverlay.propTypes = {
  show: PropTypes.bool,
  url: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PdfOverlay;
